import { Mark, markInputRule } from "@tiptap/core"

export const VariableMark = Mark.create({
  name: "variable",

  addAttributes() {
    return {
      name: {
        default: "",
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: `span[data-type="variable"]`,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      {
        ...HTMLAttributes,
        "data-type": "variable",
        style: "background-color: #38BDF8; padding: 2px 4px; border-radius: 4px; font-size: 12px; color: #101828",
      },
      0,
    ];
  },

  addInputRules() {
    return [
      markInputRule({
        find: /{{(.+?)}}/, // Se quiser, ainda pode permitir o usuário digitar as chaves
        type: this.type,
        getAttributes: match => ({ name: match[ 1 ]}),
      }),
    ];
  },
})
